import z from "zod";

/**
 * Schema for editing a product (create or update)
 */
export const editProductArgsSchema = z.object({
  id: z.number().optional(),
  code: z.number({ message: "Código é obrigatório" }),
  name: z.string({ message: "Nome é obrigatório" }).min(1, "Nome não pode estar vazio"),
  group: z.number({ message: "Grupo é obrigatório" }),
  ncmcode: z.string({ message: "Código NCM é obrigatório" })
});
